angular.module('unergie.main')
.controller('contractsCtrl', (
    $scope, $state, $location, $stateParams, AccountService, AlertManager, DataAccess, TogglerUtils, StringUtils,
    TableGeneratorService, ReferencesService, FilterMapping, BoFeaturesService, ErrorCatcher) => {
    $scope.canChooseIdGrdContract = BoFeaturesService.isFeatureOn('canChooseIdGrdContract')
    $scope.contract_status_mapping = FilterMapping.contractStatus
    $scope.suspension_status_mapping = FilterMapping.suspensionStatus
    $scope.termination_origin_mapping = FilterMapping.terminationOrigin
    const feats = BoFeaturesService.getModuleFeatures('contracts')
    $scope.isCFeatureOn = (feature) => feats[feature]

    $scope.contractsElec = {
        refreshing: false,
        show: {},
        columns: {
            'id': { label: 'Id', mode: 'search_wildcard', length: 9 },
            'fullname': { label: 'Nom', mode: 'hidden' },
            'fullname2': { label: 'Nom2', mode: 'hidden' },
            'owner': { label: 'Propriétaire', mode: 'search_wildcard', transform: StringUtils.unaccent },
            'id_prm': { label: 'PRM', mode: 'search_wildcard', length: 14 },
            'creation_ts': { label: 'Date de souscription', mode: 'search_date' },
            'retraction_end_date': { label: 'Date de rétractation', mode: 'search_date' },
            'commissioning_date': { label: 'Date activation', mode: 'search_date' },
            'decommissioning_date': { label: 'Date résiliation', mode: 'search_date' },
            'status': { label: 'Statut', mode: 'search_operator' },
            'max_power': { label: 'Puissance', mode: 'search_operator' },
            'subscription_type': { label: 'Type souscription', mode: 'search_wildcard' },
            'id_ref_goal': { label: 'Goal', mode: 'search_wildcard' },
            'id_p_calendar': { label: 'Option tarifaire', mode: 'search_wildcard', length: 4 },
            'metter_kind': { label: 'TypeCompteur', mode: 'search_wildcard' },
            'channel': { label: 'Canal', mode: 'search_wildcard' },
            'cons_profile': { label: 'Profil conso', mode: 'search_wildcard' },
            'contractBalanceStatic.balance': { label: 'Solde', mode: 'search_operator', isVisible: false },
            'suspension_status': { label: 'État coupure', mode: 'search_wildcard' },
            'provider_offer': { label: 'Offre', mode: 'search_wildcard' },
            'provider_offer_has_pot': { label: 'Offre cagnotte', mode: 'hidden' },
            'provider_offer_comments': { label: 'Offre cagnotte', mode: 'hidden' },
            'id_ref_promo': { label: 'Promo', mode: 'hidden' },
            'category': { label: 'Categorie client', mode: 'hidden' },
            'customer_id': { label: 'ID client', mode: 'hidden' },
            'termination_origin': { label: 'Origine résiliation', mode: 'search_wildcard' },
        },
    }

    if (!BoFeaturesService.isFeatureOn('showContractPayments')) {
        delete $scope.contractsElec.columns.balance
    }

    if (!TogglerUtils.isPlum()) {
        delete $scope.contractsElec.columns.channel
        delete $scope.contractsElec.columns.id_ref_goal
    }

    if (!$scope.isCFeatureOn('canViewTerminationOrigin')) {
        delete $scope.contractsElec.columns.termination_origin
    }

    if ($stateParams.prm) {
        $scope.contractsElec.instance = {}
        $scope.contractsElec.instance.page = () => 1
        $scope.contractsElec.instance.count = () => 25
        $scope.contractsElec.instance.sorting = () => ({})
        $scope.contractsElec.instance.filter = () => _.assign(_.clone($location.search()), _.pickBy({ id_prm: $stateParams.prm }))
    }

    const transformData = function (data) {
        let lastDate = null
        let alternate = false
        data.forEach((contractElec) => {
            if ((lastDate === null) || !moment(contractElec.creation_ts).startOf('day').isSame(lastDate)) {
                alternate = !alternate
                lastDate = moment(contractElec.creation_ts).startOf('day')
            }
            contractElec.alternate = alternate
        })
        return data
    }

    const refresh = () => TableGeneratorService.getTable(
        $scope.contractsElec,
        'vw-contracts',
        null,
        transformData,
        {
            search: {
                id_grd_contract: $scope.grdContracts.chosen,
            },
            orderBy: '-creation_ts',
        }
    )

    $scope.refresh = refresh

    $scope.grdContracts = {
        ids: [],
        chosen: undefined,
    }

    ReferencesService.getRef('id-grd-contracts', true).then((mapping) => {
        $scope.grdContracts.ids = _.map(mapping, 'id')
        const [chosen] = $scope.grdContracts.ids
        $scope.grdContracts.chosen = chosen
        return refresh()
    })

    ReferencesService.getRef('contractStatus').then((contractStatusMapping) => {
        $scope.contractMapping = _.map(JSON.parse(angular.toJson(contractStatusMapping)), (value, key) => ({ id: key, label: _.get(value, '[0].label_fr') }))
    })

    $scope.isActive = (state) => $state.is(state)
})
